export default "https://fenwan.cdn.bcebos.com/gamecenter/static/game/assets/imgs/pricetrend2.724c9765.png";